export default __webpack_public_path__ + "static/media/bg.5bdf4b86.jpg";